import { NativeSelect } from "@mui/material";
import { HStack, VStack } from "Components/LabIZO/Stackizo";
import { CustomFilterValueProps, FieldType, Filterable, TablizoSchema } from "Components/LabIZO/Tablizo";
import _ from "lodash";
import { ZCMsg } from "Components/Messenger/components";
import ZEye from "Components/ZEye/ZEye";
import CellExpand from "Components/LabIZO/Tablizo/_gears/CellExpand";
import { CusAuth, RoleID } from "interfaces";
import { ILogExportSchemaEntryWithAuth } from "interfaces/be.interfaces/file-export-interface";

const Table: TablizoSchema[] = [
  {
    label: "Session ID",
    name: "sessionID",
    width: 320,
    filterable: true,
  },
  {
    label: "User ID",
    name: "user_id",
    filterable: true,
  },
  {
    label: "Role",
    name: "role",
    filterable: true,
  },
  {
    label: "Lang",
    name: "lang",
    width: 85,
    filterable: true,
  },
  {
    label: "Receive Time",
    name: "recTime",
    type: "dateTime",
    transform: "datetime",
    width: 180,
    filterable: true,
    defaultSort: "desc",
  },
  // {
  //   label: "Process",
  //   name: "processTime",
  //   width: 110,
  //   type: "number",
  //   Cell: (row, field, addOns) => field + "s",
  //   filterable: true,
  // },
  {
    label: "Channel",
    name: "channel",
    width: 120,
    filterable: true,
  },
  {
    label: "Pipeline",
    name: "pipeline",
    width: 120,
    filterable: true,
  },
  {
    label: "Input Message",
    name: "Input.Content",
    filterable: true,
  },
  {
    reqAuth: "Convlog",
    reqFunc: CusAuth.NlpInfo,
    label: "Intent Alias",
    name: "intent",
  },
  {
    reqAuth: "Convlog",
    reqFunc: CusAuth.NlpInfo,
    label: "Confidence",
    name: "confidence",
    width: 120,
    coerceNumericType: "double",
  },
  {
    label: "Answer ID",
    name: "ansRes.__ans",
    valueGetter: (_data: any, field: any, _state: any) => {
      let rtn: any = [];
      if (field !== null && field !== undefined) {
        Object.keys(field).forEach((key) => {
          rtn += key + ": " + field[key];
        });
      }
      return rtn;
    },
    Cell: (_data: any, field: any, _state: any) => [<CellExpand value={field || ""} />],
    filterable: true,
  },
  {
    label: "Answer",
    name: "Response.0.msg.text",
    sortable: false,
    htmlFormat: true,
  },
  {
    label: " ",
    name: "Response",
    sortable: false,
    width: 50,
    Cell: (row: any, field: any, addOns: any) => (
      <HStack>
        <ZEye>
          <VStack>
            {_.map(field, (o, i) => {
              return <ZCMsg message_id="" key={i} cssp="zchat z" _onQuickReply={() => {}} pos="in" item={o} last={true} typingBubbles={false} showQuickRepliesAsButtons={true} HTMLEnabled={true} />;
            })}
          </VStack>
        </ZEye>
      </HStack>
    ),
  },
];

const Export: ILogExportSchemaEntryWithAuth[] = [
  {
    Header: "Session ID",
    accessor: "sessionID",
    width: 35,
  },
  {
    Header: "Receive Time",
    accessor: "recTime",
    format: "datetime",
    width: 20,
  },
  {
    Header: "Reply Time",
    accessor: "outTime",
    format: "datetime",
    width: 20,
  },
  {
    Header: "Proccess Time (s)",
    accessor: "processTime",
    width: 20,
  },
  {
    Header: "Channel",
    accessor: "channel",
    width: 20,
  },
  {
    Header: "Pipeline",
    accessor: "pipeline",
    width: 20,
  },
  {
    Header: "Role",
    accessor: "role",
    reqAuth: "Convlog",
    width: 20,
  },
  {
    Header: "Message Content",
    accessor: "Input.Content",
    width: 40,
    wrapText: true,
  },
  {
    Header: "Message Type",
    accessor: "Input.Type",
    width: 20,
  },
  {
    Header: "Language",
    accessor: "lang",
    width: 20,
  },
  {
    Header: "LiveChat",
    accessor: "liveChat",
    format: "boolean",
    width: 20,
  },
  {
    Header: "Workspace",
    accessor: "ws",
    reqAuth: "Convlog",
    reqFunc: CusAuth.NlpInfo,
    width: 20,
  },
  {
    Header: "Intent",
    accessor: "intent",
    reqAuth: "Convlog",
    reqFunc: CusAuth.NlpInfo,
    width: 25,
  },
  {
    Header: "Confidence",
    accessor: "confidence",
    reqAuth: "Convlog",
    reqFunc: CusAuth.NlpInfo,
    width: 20,
  },
  {
    Header: "Answer ID",
    accessor: "ansRes.__ans",
    width: 20,
    wrapText: true,
  },
  {
    Header: "Answer",
    accessor: "Response.0.msg.text",
    width: 45,
    wrapText: true,
  },
  {
    Header: "Template",
    accessor: "ansRes.__tans",
    width: 20,
  },
  {
    Header: "Flow",
    accessor: "ansRes.__func",
    width: 20,
  },
];

const LandFilterValue = ({ field, width, fieldState }: CustomFilterValueProps) => {
  return (
    <NativeSelect {...field} sx={{ width: width }} error={Boolean(fieldState?.error)}>
      <option value={""}></option>
      <option value={"TC"}>TC</option>
      <option value={"SC"}>SC</option>
      <option value={"EN"}>EN</option>
    </NativeSelect>
  );
};

const Filterables: Filterable[] = [
  {
    field: "sessionID",
    label: "Session ID",
    type: FieldType.text,
  },
  {
    field: "lang",
    label: "Language",
    type: FieldType.select,
    CustomFilterValue: LandFilterValue,
  },
  {
    label: "Role",
    field: "role",
    type: FieldType.select,
    CustomFilterValue: ({ field, width, fieldState }: CustomFilterValueProps) => {
      return (
        <NativeSelect {...field} sx={{ width: width }} error={Boolean(fieldState?.error)}>
          <option value={""}></option>
          <option value={[RoleID.GENERAL_PUBLIC]}>General Public</option>
          <option value={[RoleID.HEALTHCARE_PROFESSIONAL]}>Healthcare Professional</option>
          <option value={[RoleID.HEALTHCARE_PROVIDER]}>Healthcare Provider</option>
        </NativeSelect>
      );
    },
  },
  {
    field: "channel",
    label: "Channel",
    type: FieldType.select,
    CustomFilterValue: ({ field, width, fieldState }: CustomFilterValueProps) => {
      return (
        <NativeSelect {...field} sx={{ width: width }} error={Boolean(fieldState?.error)}>
          <option value={""}></option>
          <option value={"Talk2VA"}>Talk2VA</option>
          <option value={"Cinnox"}>Cinnox</option>
          <option value={"Facebook"}>Facebook</option>
          <option value={"MetaWhatsapp"}>MetaWhatsapp</option>
          <option value={"Whatsapp"}>Whatsapp</option>
        </NativeSelect>
      );
    },
  },
  {
    field: "pipeline",
    label: "Pipeline",
    type: FieldType.select,
    CustomFilterValue: ({ field, width, fieldState }: CustomFilterValueProps) => {
      return (
        <NativeSelect {...field} sx={{ width: width }} error={Boolean(fieldState?.error)}>
          <option value={""}></option>
          <option value={"intentClassifier"}>intentClassifier</option>
          <option value={"gptQa"}>gptQa</option>
          <option value={"llm-playground"}>LLM Playground</option>
        </NativeSelect>
      );
    },
  },
  {
    reqAuth: "Convlog",
    reqFunc: CusAuth.NlpInfo,
    label: "Intent",
    field: "intent",
    type: FieldType.text,
  },

  {
    label: "Input Message",
    field: "Input.Content",
    type: FieldType.text,
  },

  {
    label: "Answer ID",
    field: "ansRes.__ans",
    type: FieldType.text,
  },

  {
    reqAuth: "Convlog",
    reqFunc: CusAuth.NlpInfo,
    field: "confidence",
    label: "Confidence",
    type: FieldType.number,
  },
];

const AdvFilter: any = [];

const schema: any = {
  Table,
  Export,
  AdvFilter,
  Filterables,
};

export default schema;
